<div class="h-screen min-h-screen w-full mx-auto px-4 flex flex-col" *ngIf="config">
  <div class="absolute top-4 right-4" id="refresh-button-wrapper" *ngIf="authenticated">
    <button (click)="refresh()" class="text-gray-400 bg-transparent rounded-lg w-16 h-16 p-4 ms-auto inline-flex justify-center items-center hover:bg-neutral-600 hover:text-white">
      <fa-icon [icon]="faRefresh" class="refresh-icon text-4xl"></fa-icon>
    </button>
  </div>

  <div class="flex-none mx-auto" id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo" class="logo-image">
  </div>

  <p *ngIf="! authenticated" class="mx-auto w-96 text-center">You are not authorised to see this page</p>

  <div class="grid grid-cols-4 grid-flow-row gap-4 w-full md:mx-auto py-6 overflow-y-auto" (scroll)="onScroll($event)" *ngIf="authenticated">
    <div *ngFor="let job of jobs">
      <div class="relative w-full">
        <div class="relative overflow-hidden rounded-lg aspect-square">
          <ng-container *ngFor="let asset of filterInput(job.assets); index as i">
            <div class="item" [class.hidden]=" ! isSelected(job.id, i)" (click)="open(job.id)">
              <img [src]="asset.url" [default]="defaultImage" class="absolute block aspect-square object-contain ios-downloadable h-full w-full" alt="Source Image" [attr.data-id]="job.id" [attr.data-index]="i">
              <div class="w-full absolute top-1 right-1 z-20">
                <fa-icon [icon]="faCircleCheck" class="text-yellow-200 absolute top-0 right-1 text-3xl" *ngIf="printed.includes(job.id)"></fa-icon>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"></content-block>
</div>


<div id="preview-modal-backdrop" #modal tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-full max-h-full">
  <div class="relative p-4 w-full max-h-full" id="preview-modal">
    <!-- Modal content -->
    <div class="relative rounded-lg shadow h-[calc(100vh-2rem)]">
      <!-- Modal header -->
      <div class="flex items-center justify-between p-8 rounded-t">
        <button
          type="button"
          (click)="dismiss()"
          class="text-gray-400 bg-transparent rounded-lg w-16 h-16 p-4 ms-auto inline-flex justify-center items-center hover:bg-neutral-600 hover:text-white">
          <svg class="w-12 h-12" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <div class="grid grid-cols-4 gap-3 px-6">

        <ng-container *ngFor="let job of jobs">
          <ng-container *ngIf="job.id == jobId">
            <div class="relative aspect-square">
              <img [src]="getQRCode(job.id)" alt="QR Code" class="border-[2rem] border-white rounded-xl w-full">
            </div>

            <ng-container *ngFor="let asset of filterInput(job.assets)">
              <div class="relative aspect-square">
                <img [src]="asset.url" [default]="defaultImage" class="w-full rounded-lg bg-neutral-950 absolute aspect-square object-contain" alt="Source image">
              </div>
            </ng-container>

            <ng-container *ngFor="let asset of filterPrint(job.assets)">
              <div class="relative aspect-square cursor-pointer" (click)="print(asset)">
                <img [src]="asset.url" [default]="defaultImage" class="w-full rounded-lg bg-neutral-950 absolute aspect-square object-contain" alt="AI Generated Image">
                <div class="w-full absolute bottom-0 right-0 z-20">
                  <fa-icon [icon]="faPrint" class="text-white absolute bottom-3 right-3 text-9xl"></fa-icon>
                </div>
              </div>
            </ng-container>

          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div id="confirm-modal-backdrop" #confirm tabindex="-2" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-full max-h-full">
  <div class="relative p-4 w-96 max-h-full" id="confirm-modal">
    <!-- Modal content -->
    <div class="relative rounded-lg shadow p-4">
      <!-- Modal header -->
      <div class="flex items-center justify-between p-4 rounded-t">
        <button
          type="button"
          (click)="dismiss()"
          class="text-gray-400 bg-transparent rounded-lg text-6xl w-12 h-12 ms-auto inline-flex justify-center items-center hover:bg-neutral-600 hover:text-white">
          <svg class="w-9 h-9" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <div *ngIf="printing" class="p-4">Printing ....</div>
    </div>
  </div>
</div>
